import api from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeUserToPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('[WebPush] Push Notifications não são suportadas neste navegador.');
    return false;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('[WebPush] Permissão de notificação negada ou não concedida.');
      return false;
    }

    const registration = await navigator.serviceWorker.ready;
    if (!registration) {
      console.warn('[WebPush] Service Worker não está pronto.');
      return false;
    }

    // Busca a chave pública VAPID do backend
    const { data } = await api.get('/push/public-key');
    const publicKey = data?.publicKey;

    if (!publicKey) {
      console.warn('[WebPush] Chave pública VAPID não configurada no backend.');
      return false;
    }

    const convertedVapidKey = urlBase64ToUint8Array(publicKey);
    let subscription = await registration.pushManager.getSubscription();

    // Se já houver inscrição, envia para o backend; se falhar, renova com a chave atual
    if (subscription) {
      try {
        const subJson = subscription.toJSON();
        await api.post('/push/subscribe', {
          endpoint: subJson.endpoint,
          keys: subJson.keys
        });
        console.log('[WebPush] Dispositivo confirmado no backend!');
        return true;
      } catch (postErr) {
        console.warn('[WebPush] Inscrição antiga inválida ou chave desatualizada. Renovando...', postErr);
        try {
          await subscription.unsubscribe();
          subscription = null;
        } catch (unsubErr) {
          console.warn('[WebPush] Erro ao desinscrever inscrição anterior:', unsubErr);
        }
      }
    }

    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: convertedVapidKey
      });

      const subJson = subscription.toJSON();
      await api.post('/push/subscribe', {
        endpoint: subJson.endpoint,
        keys: subJson.keys
      });
      console.log('[WebPush] Dispositivo inscrito com sucesso para Web Push!');
      return true;
    }
  } catch (error) {
    console.error('[WebPush] Erro ao inscrever para Web Push:', error);
  }

  return false;
}

export async function unsubscribeUserFromPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      const subJson = subscription.toJSON();
      await api.post('/push/unsubscribe', {
        endpoint: subJson.endpoint
      });
      await subscription.unsubscribe();
      console.log('[WebPush] Dispositivo desinscrito com sucesso.');
    }
  } catch (error) {
    console.error('[WebPush] Erro ao desinscrever de Web Push:', error);
  }
}

